import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { FunctionComponent, useState } from 'react';
import { DetailTable } from './DetailTable';
import { Box, Typography } from '@material-ui/core';
import { TextField2 } from 'components/UI';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons';
import { faSearch } from '@fortawesome/pro-light-svg-icons';
import { reduceResolution, wbp } from 'Theme';
import Button from 'components/UI/V2/Button/Button';
import SearchName from './SearchName';
import { MarketplacePetTag } from '@spike/marketplace-model';
import { showError } from '@spike/notifications-action';

interface PositiveProps {
    tabId?: string;
    loading: boolean;
    showForm: boolean;
    newTagName: string;
    editingTag: string | null;
    personalities: Array<MarketplacePetTag>;
    setNewTagName: (name: string) => void;
    openModalDelete: (petTag: MarketplacePetTag) => void;
    addPetTagHandle?: (name: string, editingTag: string | null) => void;
    editPetTagHandle?: (petTag: MarketplacePetTag) => void;
    addOtherHandle?: (showForm: boolean) => void;
    addCancelHandle?: () => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        tabsHeaderContainer: {
            marginTop: '24px',
            borderBottom: '2px solid #E5E5E5'
        },
        tabContainer: {
            paddingBottom: '16px'
        },
        tabLabel: {
            fontSize: '14px',
            fontWeight: 500
        },
        inputBox: {},
        input: {
            'borderRadius': 30,
            'background': '#FFFFFF !important',
            'marginBottom': '20px',

            '& input': {
                '&::placeholder': {
                    opacity: 1,
                    color: '#7A7A7A'
                },

                [theme.breakpoints.down('sm')]: {
                    height: 47,
                    paddingTop: 0,
                    paddingBottom: 0,
                    fontSize: 14
                }
            },
            '& .MuiInputAdornment-root': {
                'opacity': 0.3,
                'marginRight': 0,
                'pointer-events': 'none',

                '& svg': {
                    cursor: 'default'
                }
                /*[theme.breakpoints.down('md')]: {
                    'opacity': 1,
                    '& svg': {
                        color: '#000',
                        fontWeight: 400
                    }
                }*/
            }
        },
        inputContainer: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '12px 11px',
            borderRadius: '12px',
            backgroundColor: '#F1F1F1',
            [theme.breakpoints.up('md')]: {
                paddingLeft: '22px',
                paddingRight: '22px',
                paddingBottom: '14px'
            }
        },
        addOtherContainer: {
            marginTop: '40px',
            [theme.breakpoints.down(wbp)]: {
                width: `${reduceResolution(600)}px`
            },
            [theme.breakpoints.up(wbp)]: {
                width: '600px'
            }
        },
        addOther: {
            fontWeight: 600,
            cursor: 'pointer',
            fontSize: `$16px`,
            [theme.breakpoints.down(wbp)]: {
                lineHeight: `${reduceResolution(30)}px`
            },
            [theme.breakpoints.up(wbp)]: {
                lineHeight: '30px'
            },
            [theme.breakpoints.down('sm')]: {
                color: '#92B4A7'
            }
        },
        addOtherDisabled: {
            cursor: 'default',
            color: '#666666'
        },
        tagNameField: {
            //width: '313px',
            '& input': {
                [theme.breakpoints.down(wbp)]: {
                    paddingLeft: `${reduceResolution(30)}px`
                },
                [theme.breakpoints.up(wbp)]: {
                    paddingLeft: '30px'
                }
            },
            '& .MuiOutlinedInput-root': {
                [theme.breakpoints.down(wbp)]: {
                    borderRadius: `${reduceResolution(33)}px`
                },
                [theme.breakpoints.up(wbp)]: {
                    borderRadius: '33px'
                },
                '& .MuiOutlinedInput-input:-webkit-autofill': {}
            },
            '& fieldset': {
                border: '1px #D3D3D3 solid',
                borderColor: '#D3D3D3 !important'
            },
            '& input.focus-visible ~ fieldset': {
                border: '1px solid #222222 !important'
            }
        },
        search: {
            [theme.breakpoints.down(wbp)]: {
                marginLeft: `${reduceResolution(15)}px`
            },
            [theme.breakpoints.up(wbp)]: {
                marginLeft: '5px'
            }
        },
        headerBoton: {},
        clickable: {
            cursor: 'pointer'
        },
        iconSearch: {
            [theme.breakpoints.down(wbp)]: {
                paddingLeft: `${reduceResolution(5)}px`,
                height: `${reduceResolution(18)}px`
            },
            [theme.breakpoints.up(wbp)]: {
                paddingLeft: '5px',
                height: '18px'
            }
        },
        formContainer: {
            display: 'flex',
            gap: theme.spacing(1),
            marginTop: theme.spacing(2),
            alignItems: 'center'
        },
        inputA: {
            flex: 1,
            border: '1px solid #e0e0e0',
            borderRadius: theme.shape.borderRadius,
            padding: theme.spacing(1),
            fontSize: '0.875rem'
        },
        saveButton: {
            width: '89px'
            /*backgroundColor: "#e8f5e9",
            color: "#333",
            "&:hover": {
              backgroundColor: "#c8e6c9",
            },*/
        },
        deleteButton: {
            color: '#9e9e9e'
        },
        trashIcon: {
            fontSize: '18px',
            cursor: 'pointer',
            color: 'black',
            opacity: 1,
            display: 'flex',
            width: '38px',
            alignSelf: 'center'
        },

        trashIconDisabled: {
            cursor: 'default',
            opacity: 0.7
        }
    })
);

export const Tabs: FunctionComponent<PositiveProps> = props => {
    const classes = useStyles();

    const [searchText, setSearchText] = useState('');
    const [showSearch, setShowSearch] = useState(false);

    const filteredPetTag = props.personalities.filter(petTag =>
        petTag.name.toLowerCase().includes(searchText.toLowerCase())
    );

    const clickAddOtherHandle = () => {
        props.addOtherHandle && props.addOtherHandle(true);
    };

    const clickAddPetTagHandle = () => {
        props.addPetTagHandle && props.addPetTagHandle(props.newTagName, props.editingTag);
    };

    const clickEditTagHandle = (petTag: MarketplacePetTag) => {
        props.editPetTagHandle && props.editPetTagHandle(petTag);
    };

    const clickCancelHandle = () => {
        props.addCancelHandle && props.addCancelHandle();
    };

    return (
        <>
            <SearchName
                searchText={searchText}
                showSearch={showSearch}
                onSearchChange={setSearchText}
            />
            <DetailTable
                personalities={filteredPetTag}
                loading={props.loading}
                openModalDelete={props.openModalDelete}
                editPetTagHandle={clickEditTagHandle}
            />
            {props.showForm ? (
                <Box className={classes.formContainer}>
                    <TextField2
                        id={'business_settings_pet_tags_input_pet_tag_name'}
                        className={classes.tagNameField}
                        name="name"
                        placeholder="Personality Name"
                        value={props.newTagName}
                        onChange={value => props.setNewTagName(value)}
                        required={true}
                    />
                    <Button
                        label={props.editingTag ? 'Update' : 'Save'}
                        variant="green"
                        size="medium"
                        onClick={clickAddPetTagHandle}
                        className={classes.saveButton}
                    />
                    <FontAwesomeIcon
                        id={'business_settings_pet_tags_icon_delete'}
                        icon={faTrashAlt}
                        className={
                            !props.loading ? classes.trashIcon : clsx(classes.trashIcon, classes.trashIconDisabled)
                        }
                        onClick={() => clickCancelHandle()}
                    />
                </Box>
            ) : (
                <Box className={classes.addOtherContainer}>
                    <Typography
                        id="business_settings_pet_tags_button_add_other"
                        className={!props.loading ? classes.addOther : clsx(classes.addOther, classes.addOtherDisabled)}
                        onClick={clickAddOtherHandle}
                        noWrap={true}
                    >
                        + Add other
                    </Typography>
                </Box>
            )}
        </>
    );
};

export default Tabs;
